import { type FC, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { AppRoute } from '@/common/app/routes';
import { showToast } from '@/components/ui/Notification/SwipeableToastNotification';
import { setToken } from '@/redux/reducers/userReducer';
import { useAppDispatch } from '@/redux/store';

const AuthCallback: FC = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');

    if (token) {
      dispatch(setToken(token));
      localStorage.setItem('auth_token', token);
    } else {
      showToast('Something went wrong, please try again');
    }
    navigate(token ? AppRoute.MAIN : AppRoute.LOGIN);
  }, []);

  return null;
};

export { AuthCallback };
